import { render } from "./AddTransactionPage.vue?vue&type=template&id=5ba950a3&ts=true"
import script from "./AddTransactionPage.vue?vue&type=script&lang=ts"
export * from "./AddTransactionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__